// Decide whether the current host/path is the SaaS admin app or a tenant affiliate portal.
//
// Rules (production-safe, works on a bare IP / custom domain):
//  - The PLATFORM host (the admin app) is derived from REACT_APP_PLATFORM_HOST, else from
//    REACT_APP_BACKEND_URL's host, else — when unknown — the current host is treated as admin.
//    => /login, /admin, /dashboard on the main app domain/IP always open the admin/login flow.
//  - Tenant portal is used ONLY for:
//      * a "/portal/:slug" path (dev/preview & shareable links), OR
//      * a host that is NOT the platform host (a portal subdomain like {slug}.yourdomain.com
//        or a custom white-label domain) — resolved by the backend via the Host header.

function platformHost() {
  const explicit = (process.env.REACT_APP_PLATFORM_HOST || "").trim().toLowerCase();
  if (explicit) return explicit;
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim();
  if (/^https?:\/\//i.test(raw)) {
    try { return new URL(raw).hostname.toLowerCase(); } catch { /* ignore */ }
  }
  return null; // unknown => treat the current host as the admin app
}

// A raw IP (v4/v6) is always the admin/ops entry point — never a tenant white-label domain.
function isIpHost(h) {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(h) || h.includes(":") || h === "[::1]";
}

export function detectPortal(platformHosts = []) {
  if (typeof window === "undefined") return { isPortal: false };
  const host = window.location.hostname.toLowerCase();
  const path = window.location.pathname;

  // Explicit portal links always win.
  const m = path.match(/^\/portal\/([^/]+)/);
  if (m) return { isPortal: true, slug: decodeURIComponent(m[1]), via: "path", base: `/portal/${m[1]}` };

  const ph = platformHost();
  const known = (platformHosts || []).map((h) => (h || "").toLowerCase());
  const isAppHost =
    host === "localhost" ||
    host === "127.0.0.1" ||
    isIpHost(host) ||
    host.endsWith(".preview.emergentagent.com") ||
    known.includes(host) ||                 // any registered Platform Domain (incl. the Primary)
    (ph ? host === ph : known.length === 0); // baked host, else admin only when no domains known

  // Only a distinct portal subdomain / custom white-label domain falls through to the portal.
  if (!isAppHost) return { isPortal: true, slug: null, via: "host", base: "" };
  return { isPortal: false };
}
